import styled from '@emotion/styled/macro';
import vars from '../../variables';

export const NavTabs = styled.div`
  list-style: none;
  display: flex;
`;
export const NavTab = styled.button`
  font-weight: ${vars.fontWeightMedium};
  position: relative;
  background-color: transparent;
  border: 0;
  padding-right: ${vars.spacingM};
  padding-left: ${vars.spacingM};
  padding-top: 1.9rem;
  padding-bottom: 2rem;
  height: ${vars.primaryNavHeight};
  letter-spacing: -0.02em;
  font-size: 1.6rem;
  user-select: none;
  color: ${({ textColor }) => textColor};
  -webkit-font-smoothing: subpixel-antialiased;
  opacity: 0.8;

  ${({ isSelected }) =>
    isSelected &&
    `
      opacity: 1;
      &::after {
        content: '';
        border-bottom: 2px solid ${vars.coreDarkGrey};
        position:absolute;
        bottom: -1px;
        z-index: 999;
        left: ${vars.spacingM};
        right: ${vars.spacingM};
        border-radius: 2px 2px 0px 0px;
        display: block;
      }
  `}

  &:hover {
    opacity: 1;
    cursor: pointer;
  }
`;
